<template>
  <l-layout :layout="['xs12']">
    <v-form>
      <v-card class="pa-2">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="卡口名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select :items="form.typeSelect" v-model="form.type" item-value="value" item-text="label" label="卡口类型" prepend-icon="$vuetify.icons.code"  disabled>
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="卡口描述" prepend-icon="$vuetify.icons.comment" v-model="form.description" rows="1" auto-grow  :disabled="disabledFlag"></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 v-if="form.type!=='dir'">
              <l-autocomplete
                :get-data="getParksByName"
                item-text="name"
                label="所属园区选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.park"
                :disabled="disabledFlag"
                multiple
              ></l-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="form.type==='dir'">
            <v-flex xs6>
              <v-select prepend-icon="$vuetify.icons.parkingLot" label="驶入区域"
              :items="form.entryParkId" item-text="name"  item-value="id" disabled multiple chips v-model="form.entryParkId" :disabled="disabledFlag"></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select prepend-icon="$vuetify.icons.parkingLot" label="驶出区域"
                        :items="form.departureParkId" item-text="name"  item-value="id" disabled multiple chips v-model="form.departureParkId" :disabled="disabledFlag"></v-select>
            </v-flex>
          </v-layout>
          <v-layout v-if="form.type==='dir'">
            <v-flex xs6 v-if="!disabledFlag">
              <l-autocomplete
                :get-data="getControllerByName"
                item-text="name"
                label="所属卡口选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.gate"
                :disabled="disabledFlag"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-select
                :items="form.gateSelect"
                item-text="name"
                label="所属卡口选择"
                chips
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.gate"
                :disabled="disabledFlag"></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="form.gateTypeSelect" item-text="label" item-value="value" v-model="form.gateType" label="卡口类型"
                        prepend-icon="$vuetify.icons.code" clearable
                        multiple :disabled="disabledFlag" chips></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-select :items="form.passTypeSelect" item-text="label" item-value="value" v-model="form.passType" label="通行类型"
                        prepend-icon="$vuetify.icons.location" clearable
                        :disabled="disabledFlag" chips></v-select>
            </v-flex>
            <v-flex xs6 v-if="form.type==='dir'">
              <v-select :items="form.inOrOutSelect" item-text="label" item-value="value" v-model="form.inOrOut" label="出入类型选择"
                        prepend-icon="$vuetify.icons.location" clearable :rules="[$rules.requiredS()]"
                        :disabled="disabledFlag" chips></v-select>
            </v-flex>
          </v-layout>
          <v-layout column v-if="form.qrcodeUrl!==''&&form.type==='dir'">
            <v-flex xs2 class="pl-4">
              <h3>园区二维码展示</h3>
            </v-flex>
            <v-flex xs2>
              <img :src="form.qrcodeUrl" style="width:200px;height:200px">
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="disabledFlag=!disabledFlag" v-if="disabledFlag">修改</v-btn>
            <v-btn class="primary" @click="(form.type==='unDir')?updateUnDirController():updateDirController()"  :disabled="disabledFlag" :loading="loading" v-if="!disabledFlag">提交</v-btn>
            <v-btn class="primary" :loading="loading" @click="getQrcode">生成卡口二维码</v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-form>
  </l-layout>
</template>

<script>
export default {
  name: 'controllerDetails',
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    controllerType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {
        typeSelect: [
          {value: 'dir', label: '有方向'},
          {value: 'unDir', label: '无方向'}
        ],
        gateType: [],
        gateTypeSelect: [
          {value: '0', label: '通行卡口'},
          {value: '1', label: '计费卡口'},
          {value: '2', label: '缴费卡口'},
          {value: '3', label: '边界卡口'},
        ],
        passType:"",
        passTypeSelect:[
          {value:'0',label:'人行卡口'},
          {value:'1',label:'车行卡口'}
        ],
        parkSelect: [],
        park: [],
        name: '',
        gate: '',
        gateSelect: [],
        description: '',
        latitude: '',
        longitude: '',
        entryParkId: [],
        departureParkId: [],
        qrcodeUrl: '',
        inOrOut:"",
        inOrOutSelect:[
          {value:'0',label:'入口'},
          {value:'1',label:'出口'}
        ],
      },
      disabledFlag: true,
      loading: false
    }
  },
  methods: {
    initFormData () {
      this.form.type = this.controllerType
      this.form.name = this.formData.name
      this.form.description = this.formData.description
      this.form.passType = this.formData.passType
      this.form.park = this.formData.park || []
      if (this.form.type === 'dir') {
        this.initDirController()
      }
      else {
        this.initUnDirController()
      }
    },
    async initDirController () {
      console.log(this.formData)
      let id = this.formData.gateInfo.id
      let {items} = await this.$store.dispatch('park/getUnDirControllerList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: id}})
      this.form.gate = items[0]
      this.form.gateSelect = []
      this.form.gateSelect.push(items[0])
      this.form.gateType = eval(this.formData.gateType)
      this.form.departureParkId = this.formData.departureParks
      this.form.entryParkId = this.formData.entryParks
      this.form.inOrOut = this.formData.inOrOut
      for (let i = 0; i < this.form.gateType.length; i++) {
        this.form.gateType[i] += ''
      }
      if (this.formData.extend !== null) {
        let extend = JSON.parse(this.formData.extend)
        this.form.qrcodeUrl = '/qrcode' + extend.qrcodePicPath
      }
    },
    async initUnDirController () {
      // let id = this.formData.park.id
      // let {items} = await this.$store.dispatch('park/getParkList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: id}})
      // this.form.park = []
      // this.form.park.push(items[0])
      // this.form.parkSelect = []
      // this.form.parkSelect.push(items[0])
    },
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getParksByName (val) {
      try {
        let {items} = await this.$store.dispatch('park/getParkList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    async getControllerByName (val) {
      try {
        let {items} = await this.$store.dispatch('park/getUnDirControllerList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    checkForm () {
      return true
    },
    async updateUnDirController () {
      if (this.checkForm()) {
        let parkId = []
        for(let i=0;i<this.form.park.length;i++){
          parkId.push(this.form.park[i].id)
        }
        let params = {
          'id': this.formData.id,
          'name': this.form.name,
          'description': this.form.description,
          'latitude': '',
          'longitude': '',
          'passType':this.form.passType,
          'parkId': parkId,
        }
        this.loading = true
        let res = await this.$store.dispatch('park/updateUnDirController', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.disabledFlag = true
          this.form.parkSelect = []
          this.form.parkSelect.push(this.form.park)
          this.$L.alert('success', {message: '修改成功'})
        }
        else {
          this.$L.alert('error', {message: '修改失败，原因:' + res.data.msg})
        }
      }
    },
    async updateDirController () {
      if (this.checkForm()) {
        let entryParkId = []
        let departureParkId = []
        for (let i = 0; i < this.form.entryParkId.length; i++) {
          entryParkId.push(this.form.entryParkId[i].id)
        }
        for (let i = 0; i < this.form.departureParkId.length; i++) {
          departureParkId.push(this.form.departureParkId[i].id)
        }
        let params = {
          'id': this.formData.id,
          'name': this.form.name,
          'description': this.form.description,
          'latitude': '',
          'longitude': '',
          'gateId': this.form.gate.id,
          'gateType': JSON.stringify(this.form.gateType),
          'entryParkId': entryParkId,
          'departureParkId': departureParkId,
          'passType':this.form.passType,
          "inOrOut": this.form.inOrOut
        }
        this.loading = true
        let res = await this.$store.dispatch('park/updateDirController', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.form.gateSelect = []
          this.form.gateSelect.push(this.form.gate)
          this.disabledFlag = true
          this.$L.alert('success', {message: '修改成功'})
        }
        else {
          this.$L.alert('error', {message: '修改失败，原因:' + res.data.msg})
        }
      }
    },
    async getQrcode () {
      if (this.checkForm()) {
        let entryParkId = []
        let departureParkId = []
        for (let i = 0; i < this.form.entryParkId.length; i++) {
          entryParkId.push(this.form.entryParkId[i].id)
        }
        for (let i = 0; i < this.form.departureParkId.length; i++) {
          departureParkId.push(this.form.departureParkId[i].id)
        }
        let params = {
          'id': this.formData.id,
          'name': this.form.name,
          'description': this.form.description,
          'latitude': '',
          'longitude': '',
          'gateId': this.form.gate.id,
          'gateType': JSON.stringify(this.form.gateType),
          'entryParkId': entryParkId,
          'departureParkId': departureParkId,
          'passType':this.form.passType,
          'extend': {
            'qrcodeStr': {
              '1': 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=',
              '2': 'https://smaco2.uestc.edu.cn/wx/autoLogin?aim=billDetail-gateId-' + this.formData.id,
              '3': '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
            }
          }
        }
        this.loading = true
        let res = await this.$store.dispatch('park/updateDirController', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.$L.alert('success', {message: '生成二维码成功'})
          let data = JSON.parse(res.data.data.extend)
          this.form.qrcodeUrl = '/qrcode' + data.qrcodePicPath
        }
        else {
          this.$L.alert('error', {message: '修改失败，原因:' + res.data.msg})
        }
      }
    }
  },
  created () {
    this.initFormData()
  }
}
</script>

<style scoped>

</style>
